module.exports = __webpack_public_path__ + "static/media/noImageSH.6fe7f89c.jpg";